import styles from "./PinPluginItem.module.css";
import PropTypes from "prop-types";
import Link from "shared/Link";
import Button from "shared/Button";
import {
  getOriginalPinLevel,
  getNewPinLevel,
} from "DreamStream/PluginsPage/PinTab/utils/getPinLevel";

/**
 *
 * Displays information about a pin plugin item in a pin plugin list.
 */

export function PinPluginItem({ pluginInfo, onClick, onNameClick }) {
  let originalPinText = getOriginalPinLevel(pluginInfo.originalPin);
  let newPinText = getNewPinLevel(pluginInfo.newPin);

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.iboNumber}`}>
          {pluginInfo.iboNumber}
        </Link>
      </div>
      <div className={styles.item}>{pluginInfo.name}</div>
      <div className={styles.item}>
        {pluginInfo.originalPin} - {originalPinText}
      </div>
      <div className={styles.item}>
        {pluginInfo.newPin} - {newPinText}
      </div>
      {/* <div className={styles.item}>
        {pluginInfo.date} {pluginInfo.time}
      </div>*/}
      <div className={styles.item}>
        <Button
          className={styles.detailsBtn}
          size="small"
          onClick={() => {
            onClick(pluginInfo);
          }}
        >
          Details
        </Button>
      </div>
    </div>
  );
}

PinPluginItem.propTypes = {
  /**
   * Object with the plugin info
   */
  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    originalPin: PropTypes.number,
    newPin: PropTypes.number,
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  /**
   * Function called when details is clicked
   */
  onClick: PropTypes.func,
  /**
   * Function called when the name is clicked
   */
  onNameClick: PropTypes.func,
};
